const state = () => ({
	tab: 'pending',
});

export default state;
